import { createIcon } from '@chakra-ui/react';

export const Search = createIcon({
  displayName: 'Search',
  viewBox: '0 0 24 24',
  path: (
    <path
      id="Search_Glass_-_L-2"
      data-name="Search Glass - L"
      d="M20.815,11.184a.611.611,0,0,0-.83.249,4.29,4.29,0,0,1-2.574,2.083.618.618,0,0,0,.164,1.208.5.5,0,0,0,.168-.027,5.5,5.5,0,0,0,3.324-2.685.615.615,0,0,0-.252-.829Zm.9-1.872a.632.632,0,0,0-.627-.6.617.617,0,0,0-.6.633v.433a.621.621,0,0,0,.562.667H21.1a.62.62,0,0,0,.612-.564c0-.15,0-.3,0-.456ZM16.026.59A8.748,8.748,0,0,0,9.333,14.939l-1.4,1.4-.669-.675L1.145,21.805A1.689,1.689,0,0,0,3.52,24.191l6.119-6.137-.669-.671,1.392-1.4A8.734,8.734,0,1,0,16.026.59Zm0,16.01a7.269,7.269,0,1,1,7.248-7.269A7.258,7.258,0,0,1,16.026,16.6Z"
      transform="translate(-0.745 -0.59)"
      fill="currentColor"
    />
  ),
});
